import env from './env'

const application = {
  name: 'Squids | Reseller Apps',
  path: '/app',
  prefix: env.isDev ? '/reseller' : '',
  basePath: env.isDev ? '/reseller/app' : '/app',
}

export default application
